/* eslint-disable */
export default {
  noRecords: 'Aucun enregistrement récent trouvé.',
} as const;

// @key: @#@"noRecords"@#@ @source: @#@"No recent records found."@#@
